export default __webpack_public_path__ + "static/media/2.2b6e71b1.png";